import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash.debounce';

const SearchBox = () => {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchResults = async () => {
            if (query.length > 2) {
                setLoading(true);
                try {
                    const response = await axios.get('https://igapi.heuristticminds.com/api/UserInterface/Get-GetSearchBoxList', {
                        params: { searchText: query }
                    });
                    
                    setResults(response.data);
                    
                } catch (error) {
                    console.error('API error:', error);
                } finally {
                    setLoading(false);
                }
            } else {
                setResults([]);
            }
        };

        const debouncedFetchResults = debounce(fetchResults, 300);
        debouncedFetchResults();

        return () => {
            debouncedFetchResults.cancel();
        };
    }, [query]);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && query.trim()) {
            navigate(`/search?query=${query.trim()}`);
        }
    };

    const handleSearchClick = () => {
        if (query.trim()) {
            navigate(`/search?query=${query.trim()}`);

            //const search = "all/" + item.name.replace(/ /g, "-"); // Format the name for the URL
            //navigate(`/artworks/${search}`, { state: { categoryId: 0, subCategoryId: 0, typeId: 0 } });
        }
    };

    const handleSelect = (item) => {
        console.log('Selected item:', item);
        switch (item.type) {
            case 'Subject':
                navigate(`/artwork?subject=${item.id}`);
                break;
            case 'Artist':
                navigate(`/artist/${item.id}`);
                break;
            case 'Style':
                navigate(`/style?style=${item.name}`);
                break;
            case 'Surface':
                navigate(`/surface?category=${item.name}`);
                break;
            case 'Material':
                navigate(`/material?category=${item.name}`);
                break;
            case 'Artwork':
                navigate(`/artwork/${item.id}`);
                break;
            default:
                break;
        }
    };

    const renderResults = () => {
        if (results.length === 0) return null;

        const groupedResults = results.reduce((acc, result) => {
            if (!acc[result.type]) acc[result.type] = [];
            acc[result.type].push(result);
            return acc;
        }, {});

        return (
            <div className="results-container">
                {Object.keys(groupedResults).map((type, index) => (
                    <div key={index} className="result-group">
                        <div className="group-header">{type}(s)</div>
                        {groupedResults[type].map((result, idx) => (
                            <div key={idx} className="result-item" onClick={() => handleSelect(result)}>
                                {result.name}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="search-container">
            <div className="search-box">
                <input
                    type="text"
                    id="searchBox"
                    name="searchBox"
                    placeholder="Search..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') handleKeyPress(e); // Handle Enter key press
                    }}
                />
                <button onClick={handleSearchClick}>Search</button> {/* Handle search button click */}
                {loading && <div>Loading...</div>}
                {renderResults()}
            </div>
            <style jsx>{`
                .search-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    height: 100vh;
                    margin: 0;
                }
                .search-box {
                    position: relative;
                    width: 300px;
                    margin-bottom: 20px;
                }
                .results-container {
                    width: 300px;
                    background: white;
                    border: 1px solid #ccc;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    max-height: 300px;
                    overflow-y: auto;
                }
                .group-header {
                    background: #000;
                    color: #fff;
                    padding: 5px 10px;
                    font-weight: bold;
                }
                .result-item {
                    padding: 10px;
                    cursor: pointer;
                }
                .result-item:hover {
                    background: #f0f0f0;
                }
            `}</style>
        </div>
    );
};

export default SearchBox;
